export const NEW_RECORD_ID = 'new-record';
